/**
 * icerige-atla.tsx
 *
 * NE İŞE YARAR : Klavyeyle gezen kullanıcının menüyü atlayıp doğrudan içeriğe geçmesini sağlar
 * KAYNAK SPEC  : 15-arayuz-standardi.md §13 (erişilebilirlik — klavye, odak)
 * BAĞLI OLDUĞU : `AppShell.Main` üzerindeki `id` — başka hiçbir şey
 * KULLANAN     : src/kabuk/kabuk.tsx
 * DİKKAT       : 1) BAĞLANTI SAYFANIN **İLK ODAKLANABİLİR ÖĞESİDİR** ve bu zorunludur:
 *                   sonra gelseydi kullanıcı önce atlamak istediği menüyü gezerdi.
 *                2) GÖRÜNMEZ AMA **VAR**. `display: none` ya da `visibility: hidden`
 *                   kullanılmıyor; ikisi de öğeyi odak sırasından çıkarır ve bağlantı
 *                   hiç çalışmazdı. Bunun yerine ekranın dışına konumlanıyor ve odak
 *                   alınca geri geliyor.
 *                3) HEDEF BİR **LANDMARK**TIR (`<main>`), rastgele bir kutu değil.
 *                   Ekran okuyucu kullanıcısı zaten landmark'lar arasında gezebilir;
 *                   bu bağlantı klavye kullanan ama ekran okuyucu kullanmayan kişi
 *                   içindir — iki farklı kullanıcı, iki farklı yol.
 *                4) FARE KULLANICISI BUNU HİÇ GÖRMEZ ve görmemelidir; tasarımda yeri
 *                   yoktur. Görünür bir *"içeriğe atla"* düğmesi, işlevi olmayan bir
 *                   öğe gibi okunurdu.
 * SON GÜNCELLEME: 2026-08-31 07:00:00
 */
import type { ReactElement } from 'react';

import { metin } from '../metin';

/** `AppShell.Main`in kimliği — iki yerde yazılmasın diye burada. */
export const ANA_ICERIK_KIMLIGI = 'ana-icerik';

export function IcerigeAtla(): ReactElement {
  return (
    <a
      href={`#${ANA_ICERIK_KIMLIGI}`}
      // Başlıktaki not 2 — ekran dışında ama odak sırasında.
      style={{
        position: 'absolute',
        left: '-9999px',
        top: 0,
        zIndex: 1000,
        padding: '0.5rem 1rem',
        background: 'var(--mantine-color-body)',
        border: '1px solid var(--mantine-color-ana-6)',
        borderRadius: 'var(--mantine-radius-sm)',
        color: 'var(--mantine-color-ana-7)',
      }}
      onFocus={(olay) => {
        olay.currentTarget.style.left = '0.5rem';
        olay.currentTarget.style.top = '0.5rem';
      }}
      onBlur={(olay) => {
        olay.currentTarget.style.left = '-9999px';
        olay.currentTarget.style.top = '0';
      }}
    >
      {metin('erisim.icerigeAtla')}
    </a>
  );
}
